import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Camera } from "lucide-react";

/** Miniatura de la foto de check-in/out, con click para ampliar. Se usa en el
 * log del Checador y en el Reporte de Asistencia. La foto se obtiene vía
 * fetch autenticado (blob), nunca por URL pública. */
export const AttendancePhoto = ({ path }) => {
  const [url, setUrl] = useState(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!path) return;
    let objectUrl;
    let active = true;
    api.get(`/attendance/photo/${path}`, { responseType: "blob" }).then((res) => {
      if (!active) return;
      objectUrl = URL.createObjectURL(res.data);
      setUrl(objectUrl);
    }).catch(() => {});
    return () => { active = false; if (objectUrl) URL.revokeObjectURL(objectUrl); };
  }, [path]);

  if (!path) return <span className="text-stone-400 text-xs" data-testid="attendance-photo-missing">—</span>;

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        data-testid="attendance-photo-thumb"
        className="w-9 h-9 rounded-md overflow-hidden border border-stone-200 dark:border-stone-700 hover:ring-2 hover:ring-[#1E3A8A]/40 transition-shadow bg-stone-100 dark:bg-stone-800 flex items-center justify-center"
        title="Ver foto"
      >
        {url ? <img src={url} alt="Foto de check-in" className="w-full h-full object-cover" /> : <Camera className="w-3.5 h-3.5 text-stone-400 animate-pulse" />}
      </button>
      {open && url && (
        <div
          className="fixed inset-0 z-[100] bg-black/75 flex items-center justify-center p-4"
          onClick={() => setOpen(false)}
          data-testid="attendance-photo-modal"
        >
          <img src={url} alt="Foto de check-in ampliada" className="max-h-[82vh] max-w-full rounded-lg shadow-2xl border-4 border-white" onClick={(e) => e.stopPropagation()} />
        </div>
      )}
    </>
  );
};
